import { z, ZodError } from 'zod'
import _ from 'lodash'

// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String#string_coercion
const optionalString = (v1: any): string|undefined => {
	const v2 = String(v1)
	if(v2 === 'undefined' || v2 === 'null' || v2 == '') {
		return undefined
	}
	return v2
}

// tweaked from SerializedError from @reduxjs/toolkit
export const ZFusionError = z.object({
	area: z.string(),
	name: z.string(),
	message: z.string(),
	stack: z.optional(z.string()),
	code: z.optional(z.string()),
	userFriendly: z.optional(z.boolean()),
})
export type FusionError = z.infer<typeof ZFusionError>

export const isZodError = (err: unknown): err is ZodError => {
	return (
		(err instanceof ZodError) ||
		(err instanceof Error && err.name === 'ZodError')
	)
}

export const ZodPrettifyErrorName = 'ZodPrettifyError'

// inspired by miniSerializedError from @reduxjs/toolkit
export const serializeFusionError = (area: string, err: any): FusionError => {
	if(isZodError(err)) {
		const zerr2 = new Error(z.prettifyError(err))
		zerr2.name = ZodPrettifyErrorName
		err = zerr2
	}
	// produce stack trace for string error messages
	if(_.isString(err)) {
		err = new Error(err)
	}
	if(typeof err === 'object' && err !== null) {
		return {
			area: optionalString(err.area) ? `${area} | ${err.area}` : area,
			name: optionalString(err.name) ?? 'Error',
			message: optionalString(err.message) ?? '(no message)',
			stack: optionalString(err.stack),
			code: optionalString(err.code),
			userFriendly: Boolean(err.userFriendly),
		}
	}
	return {
		area,
		name: 'Error',
		message: optionalString(err) ?? '(no message)',
		userFriendly: false,
	}
}

export const serializePrettyJsonFusionError = (area: string, err: any) => {
	return JSON.stringify(serializeFusionError(area, err), null, 4)
}
